// jQuery
jQuery(function ($) {
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav-wrap').toggleClass('is-open');
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
    var hidden = $('.gnav-wrap').attr('aria-hidden') === 'true';
    $('.gnav-wrap').attr('aria-hidden', !hidden);
  });
  $('.gnav-wrap a').on('click', function () {
    $('.gnav-wrap').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
    $('.gnav-wrap').attr('aria-hidden', 'true');
  });
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

  // テキストアニメーション
  function EachTextAnimeControl() {
    $('.eachTextAnime').each(function () {
      var elemPos = $(this).offset().top - 50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        // クラスごとに異なるディレイを追加
        if ($(this).hasClass('_text01')) {
          $(this).addClass("appeartext");
        } else if ($(this).hasClass('_text02')) {
          setTimeout(() => $(this).addClass("appeartext"), 1000); // 0.5秒ディレイ
        } else if ($(this).hasClass('_text03')) {
          setTimeout(() => $(this).addClass("appeartext"), 2000); // 0.5秒ディレイ
        }
      } else {
        $(this).removeClass("appeartext");
      }
    });
  }

  $(window).scroll(function () {
    EachTextAnimeControl();
  });

  $(window).on('load', function () {
    // テキストアニメーションのセットアップ
    var element = $(".eachTextAnime");
    element.each(function () {
      var text = $(this).text();
      var textbox = "";
      text.split('').forEach(function (t, i) {
        if (t !== " ") {
          if (i < 10) {
            textbox += '<span style="animation-delay:.' + i + 's;">' + t + '</span>';
          } else {
            var n = i / 10;
            textbox += '<span style="animation-delay:' + n + 's;">' + t + '</span>';
          }
        } else {
          textbox += t;
        }
      });
      $(this).html(textbox);
    });

    EachTextAnimeControl();
  });
});

// JavaScript

// マウスストーカー
const mouseStalker = document.getElementById('g-ms');
let msPos = {
  // マウスストーカーの位置
  s: {
    x: document.documentElement.clientWidth / 2,
    y: document.documentElement.clientHeight / 2
  },
  // マウスポインターの位置
  m: {
    x: document.documentElement.clientWidth / 2,
    y: document.documentElement.clientHeight / 2
  }
};

// マウスストーカーをactiveにする
if (window.matchMedia("(pointer: fine)").matches) {
  document.addEventListener("mousemove", msActivate);
}
function msActivate() {
  mouseStalker.classList.add('g-ms-active');
  document.removeEventListener("mousemove", msActivate);
  // mouseの位置セット
  document.addEventListener('mousemove', function (e) {
    msPos.m.x = e.clientX;
    msPos.m.y = e.clientY;
  });
  // アニメーション開始
  requestAnimationFrame(msPosUpdate);
}

// マウスストーカーを動かす関数
function msPosUpdate() {
  msPos.s.x += (msPos.m.x - msPos.s.x) * 0.1;
  msPos.s.y += (msPos.m.y - msPos.s.y) * 0.1;
  const x = Math.round(msPos.s.x * 10) / 10;
  const y = Math.round(msPos.s.y * 10) / 10;
  mouseStalker.style.transform = `translate3d(` + x + 'px,' + y + 'px, 0)';
  requestAnimationFrame(msPosUpdate);
}

// hover時にclass追加
const stalkerLinkObj = document.querySelectorAll('a, button, .msl');
for (let i = 0; i < stalkerLinkObj.length; i++) {
  stalkerLinkObj[i].addEventListener('mouseover', function () {
    mouseStalker.classList.add('g-ms-hover');
  });
  stalkerLinkObj[i].addEventListener('mouseout', function () {
    mouseStalker.classList.remove('g-ms-hover');
  });
}

// パララックス
const image = document.querySelectorAll('.js-parallax');
new simpleParallax(image, {
  overflow: !0,
  delay: .6,
  orientation: "down"
});